<template>
  <CRow>
    <CCol md="12">
      <GuestsActions :event="event" :items="items" :hasTables="hasTables" @export-attendance="downloadExcelAttendance"
        @export-guests="downloadExcel" @import-guests="importModal" @send-remember="sendMasiveInvitation"
        @send-invitation="sendMasiveFirstInvitation"
        @send-message="sendMasiveMessage" @send-save-date="sendSaveTheDateMessage" @send-tables="sendTableMessage"
        @send-preinvitation="sendPreInvitationMessage" @send-event-reminder="sendEventReminderMessage"
        @assign-table="assignTable" @new-guest="storeModal" @send-masive-tickets-email="sendMasiveTickets"
        @send-excel-email="sendGuestsExcelByEmail" @schedule-sends="scheduleSends" @import-history="importHistoryModal" />

      <GuestsFilters :confirm="confirmSelect" :table="tableSelect" :tables-options="tablesOptions" :confirm-options="confirmOptions"
        @update:confirm="onConfirmFilterChange" @update:table="onTableFilterChange" />

      <CAlert v-if="cooldownStatus.event_in_cooldown" color="warning">
        Este evento está en cooldown hasta {{ cooldownStatus.event_cooldown_until | datetime }}.
      </CAlert>
      <CAlert v-else-if="cooldownStatus.recipients_in_cooldown > 0" color="info">
        Hay {{ cooldownStatus.recipients_in_cooldown }} destinatarios en cooldown.
      </CAlert>

      <GuestsTable :event="event" :items="items" :hover="true" :striped="true" :border="true" :small="true"
        :fixed="true" :dark="false" :hasTables="hasTables" @edit-guest="updateModal" @delete-guest="deleteModal"
        @confirm-guest="confirmModal" @send-guest-reminder="sendReminderModal" @send-guest-invitation="sendInvitationModal" @send-guest-tickets="sendTicketModal"
        @download-tickets="downloadTickets" @external-download-tickets="externalDownloadTickets"
        @history-invitation="historyInvitationModal" @open-conversation="openConversationModal" />
      <GuestsMetrics :event="event" :metrics="metrics" />
    </CCol>
    <!-- MODALES -->
    <GuestModal ref="addModal" @refreshItems="changeFilters"></GuestModal>
    <ConfirmGuestModal ref="confirmModal" @refreshItems="changeFilters"></ConfirmGuestModal>
    <ImportGuestsModal ref="importModal" @refresh="changeFilters"></ImportGuestsModal>
    <ImportHistoryModal ref="importHistoryModal" @refresh="changeFilters"></ImportHistoryModal>
    <DeleteModal ref="deleteModal" @confirm="deleteProcess"></DeleteModal>

    <!-- MENSAJES DE WHATSAPP -->
    <SendInvitationModal ref="sendInvitationModal"></SendInvitationModal>
    <SendMasiveInvitationModal ref="sendMasiveInvitationModal"></SendMasiveInvitationModal>
    <SendMasiveMessageModal ref="sendMasiveMessageModal"></SendMasiveMessageModal>
    <SendSaveTheDateModal ref="sendSaveTheDateModal"></SendSaveTheDateModal>
    <SendTableMessageModal ref="sendTableMessageModal"></SendTableMessageModal>

    <!-- GENERALES -->
    <AssignTable ref="assignTableModal" @refreshItems="changeFilters"></AssignTable>
    <HistoryInvitationModal ref="historyInvitationModal"></HistoryInvitationModal>
    <GuestConversationModal ref="guestConversationModal"></GuestConversationModal>

    <!-- MENSAJES DE EMAIL -->
    <SendTicketModal ref="sendTicketModal"></SendTicketModal>
    <SendMasiveTicketsModal ref="sendMasiveTicketsModal"></SendMasiveTicketsModal>
    <SendGuestsExcelModal ref="sendGuestsExcelModal"></SendGuestsExcelModal>
  </CRow>
</template>

<script>

// detalle
import GuestsActions from '@/components/events/event/detail/guests/GuestsActions.vue';
import GuestsFilters from '@/components/events/event/detail/guests/GuestsFilters.vue';
import GuestsMetrics from '@/components/events/event/detail/guests/GuestsMetrics.vue';
import GuestsTable from '@/components/events/event/detail/guests/GuestsTable.vue';

// Invitados
import GuestModal from '@/components/events/event/detail/guests/GuestModal.vue';
import ConfirmGuestModal from '@/components/events/event/detail/guests/ConfirmGuestModal.vue';
import ImportGuestsModal from '@/components/events/event/detail/guests/ImportGuestsModal.vue';
import ImportHistoryModal from '@/components/events/event/detail/guests/import-history/ImportHistoryModal.vue';
import DeleteModal from '@/components/global/ConfirmModal.vue';

// Whatsapp
import SendInvitationModal from '@/components/events/event/detail/sendWhatsapp/SendInvitationModal.vue';
import SendMasiveInvitationModal from '@/components/events/event/detail/sendWhatsapp/SendMasiveInvitationModal.vue';
import SendMasiveMessageModal from '@/components/events/event/detail/sendWhatsapp/SendMasiveMessageModal.vue';
import SendTableMessageModal from '@/components/events/event/detail/sendWhatsapp/SendTableMessageModal.vue';
import SendSaveTheDateModal from '@/components/events/event/detail/sendWhatsapp/SendSaveTheDateModal.vue';

// Email
import SendMasiveTicketsModal from '@/components/events/event/detail/sendEmail/SendMasiveTicketsModal.vue';
import SendTicketModal from '@/components/events/event/detail/sendEmail/SendTicketModal.vue';
import SendGuestsExcelModal from '@/components/events/event/detail/sendEmail/SendGuestsExcelModal.vue';

// Generales
import AssignTable from '@/components/events/event/detail/tables/AssignTableModal.vue';
import HistoryInvitationModal from '@/components/events/event/detail/guests/HistoryInvitationModal.vue';
import GuestConversationModal from '@/components/events/event/detail/guests/GuestConversationModal.vue';
import ws from '@/services/events_guests';
import ws_event from '@/services/events';
import ws_table from '@/services/events_tables';
import store from '@/store'

export default {
  name: 'GuestsModule',
  props: {
    event: { type: Object, required: true }
  },
  components: {
    GuestsActions,
    GuestsFilters,
    GuestsMetrics,
    GuestsTable,

    GuestModal,
    ConfirmGuestModal,
    ImportGuestsModal,
    ImportHistoryModal,
    DeleteModal,

    SendInvitationModal,
    SendMasiveInvitationModal,
    SendMasiveMessageModal,
    SendTableMessageModal,
    SendSaveTheDateModal,

    SendTicketModal,
    SendMasiveTicketsModal,
    SendGuestsExcelModal,

    AssignTable,
    HistoryInvitationModal,
    GuestConversationModal
  },
  data() {
    return {
      items: [],
      confirmSelect: "",
      tableSelect: "",
      tablesOptions: [],
      event_id: this.$route.params.id,
      confirmOptions: [
        { label: "Todos", value: "" },
        { label: "Pendiente", value: 0 },
        { label: "Incompleta", value: 3 },
        { label: "Si", value: 1 },
        { label: "No", value: 2 }
      ],
      metrics: {
        total: "0",
        assign: "0",
        confirm: "0",
        pending: "0",
        incomplete: "0",
        attendance: "0"
      },
      cooldownStatus: {
        cooldown_minutes: 0,
        event_in_cooldown: false,
        event_cooldown_until: null,
        recipients_in_cooldown: 0,
      },
      hasTables: 0,
      idToDelete: ""
    }
  },
  computed: {
  },
  mounted() {
    this.initialize()
  },
  methods: {
    // SERVICIOS
    async initialize() {
      this.loading()

      await this.loadTables()
      await this.loadGuests()
      await this.loadCooldownStatus()
      await this.getMetrics()

      this.loaded()
    },
    async loadTables() {
      const response = await ws_table.get(this.event_id)
      if (response.type === "success") {
        this.hasTables = response.data.length
        this.tablesOptions = await this.$parseSelectOptions(
          response.data,
          "id",
          "name",
          [{ label: "Todos", value: "" }]
        )
      }
    },
    async loadGuests() {
      const filters = this.getFilters()
      const response = await ws.get(filters)
      if (response.type === "success") {
        this.items = response.data
      }
    },
    async getMetrics() {
      const response = await ws_event.getTicketsMetrick(this.event_id)
      if (response.type === "success") {
        this.metrics = response.data
      }
    },
    async loadCooldownStatus() {
      const response = await ws.cooldownStatus({ event_id: this.event_id })
      if (response.type === 'success' && response.data) {
        this.cooldownStatus = response.data
      }
    },
    async changeFilters() {
      await this.loadGuests()
      await this.loadCooldownStatus()
      await this.getMetrics()
    },

    async onConfirmFilterChange(value) {
      this.confirmSelect = value
      await this.changeFilters()
    },

    async onTableFilterChange(value) {
      this.tableSelect = value
      await this.changeFilters()
    },

    getFilters() {
      return {
        event_id: this.event_id,
        is_confirm: this.confirmSelect,
        event_table_id: this.tableSelect
      }
    },
    /* === ACCIONES === */

    storeModal() {
      this.$refs.addModal.storeModal(this.event.id, this.event.contact_method)
    },

    importModal() {
      this.$refs.importModal.importExcelModal(this.event.id)
    },

    importHistoryModal() {
      this.$refs.importHistoryModal.showHistoryModal(this.event.id)
    },

    updateModal(item) {
      this.$refs.addModal.updateModal(item, this.event.contact_method)
    },

    confirmModal(item) {
      this.$refs.confirmModal.storeModal(item)
    },

    sendInvitationModal(item) {
      this.$refs.sendInvitationModal.showSendModal(item, this.event, 'invitation')
    },

    sendReminderModal(item) {
      this.$refs.sendInvitationModal.showSendModal(item, this.event, 'reminder')
    },

    sendTicketModal(item) {
      this.$refs.sendTicketModal.showSendModal(item, this.event)
    },

    sendMasiveTickets() {
      this.$refs.sendMasiveTicketsModal.showSendModal(this.event.id, this.event)
    },

    sendGuestsExcelByEmail() {
      this.$refs.sendGuestsExcelModal.showSendModal(this.event, this.getFilters())
    },

    scheduleSends() {
      this.$emit('open-scheduled-modal')
    },

    sendPreInvitationMessage() {
      this.$refs.sendSaveTheDateModal.showSendModal(this.event.id, this.event, 'preinvitation')
    },

    sendEventReminderMessage() {
      this.$refs.sendSaveTheDateModal.showSendModal(this.event.id, this.event, 'event_reminder')
    },

    sendMasiveInvitation() {
      this.$refs.sendMasiveInvitationModal.showSendModal(this.event.id, this.event, 'reminder')
    },

    sendMasiveFirstInvitation() {
      this.$refs.sendMasiveInvitationModal.showSendModal(this.event.id, this.event, 'invitation')
    },

    sendMasiveMessage() {
      this.$refs.sendMasiveMessageModal.showSendModal(this.event.id, this.event)
    },

    sendTableMessage() {
      this.$refs.sendTableMessageModal.showSendModal(this.event.id, this.event)
    },

    sendSaveTheDateMessage() {
      this.$refs.sendSaveTheDateModal.showSendModal(this.event.id, this.event)
    },

    assignTable() {
      this.$refs.assignTableModal.showAssignModal(this.event.id)
    },

    historyInvitationModal(item) {
      this.$refs.historyInvitationModal.showHistoryModal(item.id)
    },

    openConversationModal(item) {
      this.$refs.guestConversationModal.showConversationModal(item)
    },
    async downloadExcel() {
      this.loading()
      await ws.downloadExcel(this.getFilters())
      this.loaded()
    },

    async downloadExcelAttendance() {
      this.loading()
      await ws.downloadExcelAttendance(this.getFilters())
      this.loaded()
    },

    async downloadTickets(item) {
      this.loading()
      await ws.downloadTickets({ guest_id: item.id })
      this.loaded()
    },

    externalDownloadTickets(item) {
      const routeData = this.$router.resolve({
        name: 'external-download-tickets',
        params: { code: item.token }
      })
      window.open(routeData.href, '_blank')
    },

    deleteModal(item) {
      this.idToDelete = item.id
      this.$refs.deleteModal.show(
        "dark",
        "Eliminar Invitado",
        "¿Estás seguro que deseas eliminar el invitado?",
        `<span style='font-size: 16px;font-weight: bold;'>${item.name}</span>`
      )
    },

    async deleteProcess() {
      this.loading()
      const response = await ws.delete({ id: this.idToDelete })
      if (response.type === "success") {
        await this.changeFilters()
      }
      this.showToast(response.type, response.message)
      this.loaded()
    },

    showToast(type, message) {
      store.commit('toast', { color: type, message })
    },

    loading() { store.commit('loading') },
    loaded() { store.commit('loaded') }
  },
}
</script>
<style>

</style>